var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-img',{class:{
      'v-image--sm': this.$vuetify.breakpoint.smAndDown,
      'v-image--md': this.$vuetify.breakpoint.mdAndDown
    },attrs:{"src":"img/sidebar-2.jpg","gradient":"to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)","height":"0"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }